var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFulfilledDocument = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4328 14.3356V9.33929L15.5935 0.5H4.7899C3.74798 0.5 2.74873 0.913902 2.01198 1.65065C1.27523 2.3874 0.861328 3.38665 0.861328 4.42857V28C0.861328 29.0419 1.27523 30.0412 2.01198 30.7779C2.74873 31.5147 3.74798 31.9286 4.7899 31.9286H14.9763C14.8546 31.2919 14.7616 30.6359 14.6999 29.9643H4.7899C4.26894 29.9643 3.76932 29.7573 3.40094 29.389C3.03256 29.0206 2.82561 28.521 2.82561 28V4.42857C2.82561 3.90761 3.03256 3.40799 3.40094 3.03961C3.76932 2.67124 4.26894 2.46429 4.7899 2.46429H15.5935V6.39286C15.5935 7.1743 15.9039 7.92373 16.4565 8.4763C17.009 9.02886 17.7585 9.33929 18.5399 9.33929H22.4685V14.3353C22.7907 14.28 23.1181 14.2515 23.4498 14.2515C23.7821 14.2515 24.11 14.28 24.4328 14.3356ZM5.77204 12.2857C5.77204 11.7433 6.21176 11.3036 6.75419 11.3036H12.647C13.1895 11.3036 13.6292 11.7433 13.6292 12.2857C13.6292 12.8281 13.1895 13.2679 12.647 13.2679H6.75419C6.21176 13.2679 5.77204 12.8281 5.77204 12.2857ZM5.77204 18.1786C5.77204 17.6362 6.21176 17.1964 6.75419 17.1964H15.5935C16.1359 17.1964 16.5756 17.6362 16.5756 18.1786C16.5756 18.721 16.1359 19.1607 15.5935 19.1607H6.75419C6.21176 19.1607 5.77204 18.721 5.77204 18.1786ZM5.77204 24.0714C5.77204 23.529 6.21176 23.0893 6.75419 23.0893H13.6292C14.1716 23.0893 14.6113 23.529 14.6113 24.0714C14.6113 24.6139 14.1716 25.0536 13.6292 25.0536H6.75419C6.21176 25.0536 5.77204 24.6139 5.77204 24.0714Z",
    fill: "#3B3B3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69824 30.9448H12.6447",
    stroke: "#3B3B3B",
    strokeWidth: 1.96429,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6445 30.9448H15.591",
    stroke: "#3B3B3B",
    strokeWidth: 1.96429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4497 18.9642V12.2856",
    stroke: "#3B3B3B",
    strokeWidth: 1.96429,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5713 26.4286L23.107 29.9644L31.357 21.7144",
    stroke: "#3B3B3B",
    strokeWidth: 1.88571,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFulfilledDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fulfilled-document.16a0f5958415ba30f4647411c5cdae5d.svg";